// extracted by mini-css-extract-plugin
module.exports = {"root":"Pane_root__3yCG5"};